import React from "react";
import { Route } from "react-router-dom";
import Footer from "../layouts/UserNav/Footer";
import NavComponent from "../layouts/UserNav/Navbar";

const PublicRoute = ({ component: Component, ...rest }) => (
    <>
    <NavComponent/>
    <Route
        {...rest}
        render={props =>
                <Component {...props} />   
        }
    />
    <Footer/>
    </>
);

export default PublicRoute;